import { styled } from "@mui/material";

import { organisationBlue } from "@/theme/colors";

export const StyledTable = styled("table")(
  ({ theme }) => `
  --table-accent: color-mix(in srgb, var(--foreground) 5%, transparent);
  border-radius: 8px;
  border-spacing: 0;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.10);
  margin-bottom: ${theme.spacing(3)};
  margin-top: ${theme.spacing(2)};
  overflow: hidden;
  width: 100%;
  table-layout: auto;

  thead {
    background: var(--table-accent);

    th {
      padding: ${theme.spacing(3)} 0;
      text-align: left;

      &:first-of-type {
        width: 100px;
        display: none;

        @media (width >= 640px) {
          display: table-cell;
        }
      }
      &:nth-of-type(2) {
        padding: 0 ${theme.spacing(1)};

        @media (width >= 640px) {
          padding: ${theme.spacing(1)} 0;
        }
      }
    }
  }

  td {
    border-bottom: 1px solid var(--table-accent);
    color: var(--foreground);
    padding: ${theme.spacing(1)} 0;
  }

  tr:last-of-type {
    td {
      border-bottom: none;
    }
  }

  tbody tr td {
    &:first-of-type {
      display: none;

      @media (width >= 640px) {
        display: table-cell;
        width: 100px;
      }
    }
    &:nth-of-type(2) {
      padding: 0 ${theme.spacing(1)};
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 200px;

      @media (width >= 640px) {
        padding: ${theme.spacing(1)} 0;
      }
    }
    &:last-child {
      text-align: center;
      width: 60px;
    }
  }
`,
);

export const ThIconButton = styled("button")`
  background: none;
  border: none;
  display: inline;
  font-weight: bold;
  font-size: 1em;
  padding: 0;
  position: relative;
  top: 2px;

  svg {
    margin-left: 5px;
  }
`;

export const Popup = styled("div")(
  ({ theme }) => `
  background: ${theme.palette.common.white};
  border-radius: 8px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.10);
  padding: ${theme.spacing(2)};
`,
);

export const TooltipWrapper = styled("div")`
  align-items: center;
  display: flex;
`;

export const LetterCircle = styled("div")(
  ({ theme }) => `
  border-radius: 30px;
  background: ${organisationBlue};
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 56px;
  min-width: 56px;
  height: 56px;
  width: 56px;
  color: ${theme.palette.common.white};
  margin-left: ${theme.spacing(2)};
`,
);

export const Status = styled("span")<{ active: boolean }>`
  color: ${(props) => (props.active ? "#4caf50" : "var(--foreground)")};
`;

export const DataStatus = styled("div")(
  ({ theme }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  padding: ${theme.spacing(4)} 0;

  span {
    margin-right: ${theme.spacing(1)};
  }
`,
);

export const Pagination = styled("div")(
  ({ theme }) => `
  display: flex;
  justify-content: center;
  margin-bottom: ${theme.spacing(3)};

  button {
    border-radius: 50%;
    border: 1px solid ${theme.palette.primary.main};
    background: none;
    color: ${theme.palette.primary.main};
    width: 48px;
    height: 48px;
    cursor: pointer;
    margin: 0 5px;

    [data-theme='dark'] & {
      border: 1px solid var(--foreground);
      color: var(--foreground);
    }
  }
`,
);

export const NumericalItems = styled("button")<{ active: boolean }>(
  ({ theme, active }) => `
 ${
   active
     ? `
      background: ${theme.palette.primary.main};
      color: ${theme.palette.common.white};
      `
     : null
 }
  }
`,
);

export const StyledH2 = styled("h2")`
  font-size: 2em;
`;

export const SearchField = styled("div")(
  ({ theme }) => `
  margin-top: ${theme.spacing(2)};
  max-width: 400px;
`,
);

export const FilterPills = styled("div")(
  ({ theme }) => `
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacing(1)};
  margin-top: ${theme.spacing(2)};
`,
);
